export const MARGIN_RIGHT = 24;
